@let modelData = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('previewFile')) {
    @if (isNotNil(modelData.previewFile)) {
      <app-image-thumbnail>
        <img
          [ngSrc]="modelData.previewFile.url"
          [fill]="true"
          [alt]="modelData.previewFile.alt"
          class="object-contain" />
      </app-image-thumbnail>
    } @else {
      <app-image-thumbnail-unsupported />
    }
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
